<script lang="ts" setup>
import {
  IonContent,
  IonHeader,
  IonToolbar,
  IonPage,
  IonButton,
} from "@ionic/vue";
import { useI18n } from "@/composables/useI18n";
import { ref } from "vue";
import BackButton from "@/components/ui/BackButton.vue";
import { useRouter } from "vue-router";

const emit = defineEmits<{
  (event: "configure"): void;
}>();

const router = useRouter();
const { t } = useI18n();

const image1 = ref();

function handleImageClick(image: any) {
  image.$viewer.show();
}
</script>
<template>
  <ion-page>
    <ion-header mode="ios">
      <ion-toolbar class="transparent-toolbar ion-padding-start" mode="ios">
        <div class="page-toolbar">
          <back-button @back="router.push('ApplicationConfigurationIndex')" />
        </div>
      </ion-toolbar>
    </ion-header>
    <ion-content :fullscreen="true" :scroll-y="false" class="hide-scrollbar">
      <div class="app-configuration-help-content">
        <div class="app-configuration-help-hint">
          <div>{{ t("common.findApplicationSubdomain") }}</div>
          <pre class="ion-padding app-configuration-text-container">{{
            t("common.helpApplicationSubdomain")
          }}</pre>
        </div>
        <div class="app-configuration-images">
          <div>
            <img
              ref="image1"
              v-viewer.static="{
                navbar: 0,
                toolbar: 0,
                transition: false,
                movable: false,
              }"
              load="lazy"
              src="/img/subdomain-configuration-help.png"
              @click.stop.prevent="handleImageClick(image1)"
            />
          </div>
        </div>
      </div>
    </ion-content>
    <ion-footer class="ion-no-border">
      <div class="app-configuration-action-button-container">
        <ion-button
          class="ion-margin-top"
          color="secondary"
          mode="ios"
          @click="emit('configure')"
        >
          <div class="app-configuration-button-content">
            <font-icon color="#ffffff" name="edit" size="1.375" />
            <div>
              {{ t("common.subdomainTitle") }}
            </div>
          </div>
        </ion-button>
      </div>
    </ion-footer>
  </ion-page>
</template>

<style scoped></style>
